const text_tab = () => {
    $('.text-tab-module .tab').on('click', function () {

        if (!$(this).hasClass('active')) {
            let tabIndex = $(this).data('tab-index');

            console.log(tabIndex);
            $(this).parents('.text-tab-module').find('.tab').removeClass('active');
            $(this).parents('.text-tab-module').find('.tab[data-tab-index="' + tabIndex + '"]').addClass('active');

            if ($(this).hasClass('mobile')) {
                $(this).parents('.text-tab-module').find('.tab-content:visible').slideUp();
                $(this).parents('.text-tab-module').find('.tab-content[data-tab-index="' + tabIndex + '"]').slideDown();
                // $('.text-tab-module .tab-content:visible').slideUp();
                // $('.text-tab-module .tab-content[data-tab-index="' + tabIndex + '"]').slideDown();
            } else {
                $(this).parents('.text-tab-module').find('.tab-content:visible').hide();
                $(this).parents('.text-tab-module').find('.tab-content[data-tab-index="' + tabIndex + '"]').fadeIn();
                // $('.text-tab-module .tab-content:visible').hide();
                // $('.text-tab-module .tab-content[data-tab-index="' + tabIndex + '"]').fadeIn();
            }
        }
    });
};

export default text_tab;